import { render, staticRenderFns } from "./ticket-note-edit.vue?vue&type=template&id=6967a9f4"
import script from "./ticket-note-edit.vue?vue&type=script&lang=js"
export * from "./ticket-note-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports